import { SamplerNode } from './nodes/SamplerNode';

const createLoopNode = (loop) =>
   new SamplerNode(
      {
         buffer: loop.buffer,
         loop: true,
      },
      0
   );

export { createLoopNode };
